import { generateUuid } from '@/utils/id.utils';
import {
  isOfflineSubmissionError,
  isUnauthorizedSubmissionError,
} from './offlineReportSubmissionQueue.submission';
import type {
  EnqueueReportSubmissionInput,
  QueuedReportSubmission,
} from './offlineReportSubmissionQueue.types';

export const shouldStopQueueProcessing = (error: unknown): boolean =>
  isOfflineSubmissionError(error) || isUnauthorizedSubmissionError(error);

export const buildQueuedSubmission = (
  input: EnqueueReportSubmissionInput,
): QueuedReportSubmission => {
  const submissionId = generateUuid();
  const stableReportCode = input.reportCode ?? submissionId;

  return {
    id: submissionId,
    values: input.values,
    mode: input.mode,
    reportCode: stableReportCode,
    versionNote: input.versionNote,
  };
};
